<template>
  <div class="ft">
    <el-row :gutter="10">
      <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1">
        <div class="grid-content ep-bg-purple" />
      </el-col>
      <el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11">
        <div class="grid-content ep-bg-purple" />
        <div class="ft_a">主办单位名称： 广州超交市场咨询服务有限公司</div>
      </el-col>
      <el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11">
        <div class="grid-content ep-bg-purple-light" />
        <div class="ft_a">
          <a
            href=" https://beian.miit.gov.cn/"
            target="_blank"
            :underline="false"
          >
            ICP备案/许可证号： 粤ICP备2025360441号</a
          >
        </div>
      </el-col>
      <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1">
        <div class="grid-content ep-bg-purple-light" />
      </el-col>
    </el-row>
  </div>
</template>

<script setup></script>

<style scoped>
.ft {
  height: 140px;
  background-color: rgb(51, 51, 51);
  color: #ccc;
  font-size: 14px;
  margin-top: 50px;

  .ft_a {
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      color: #ccc;
    }
  }
}
</style>
